import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import AgencyContractEditView from 'features/Agency/components/AgencyContractEditView';
import AgencySaleCreateContractView from 'features/Agency/components/AgencySaleCreateContractView';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AgencySaleOrderWizardView from 'features/Agency/components/AgencySaleOrderWizardView';
import ChargeHelper from 'features/Charge/chargeHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import EmptyView from 'general/components/Others/EmptyView';
import FileUploadView from 'general/components/quybka/Uploads/FileUploadView';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import useRouter from 'hooks/useRouter';
import { t } from 'i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import AgencySaleCreateTechnicalAcceptanceView from '../AgencySaleCreateTechnicalAcceptanceView';
import AgencySaleCreateFinancialAcceptanceView from '../AgencySaleCreateFinancialAcceptanceView';
import AppendicesListView from '../AppendicesListView';
import AgencySaleCreateAppendixView from '../AgencySaleCreateAppendixView';
import AppConstants from 'general/constants/AppConstants';

AgencySaleDetailView.propTypes = {
  saleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

function AgencySaleDetailView({ saleId }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { user, permissionList } = useSelector((state) => state.auth);
  const isAgency = user?.role === 'AGENCY';
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const isAdminMain = (user?.role === 'ADMIN' || user?.role === 'OPERATOR') && !Utils.isValid(user?.position);
  const isAdminMaintainer = (user?.role === 'ADMIN' || user?.role === 'OPERATOR') && (['INFRA_ENGINEERING_MANAGER', 'INFRA_ENGINEER'].includes(user?.position));
  const isSale = user?.role === 'AGENCY' && user?.agency?.primaryRole === AgencyConstants.AgencyRole.SALE;
  const config = useSelector((state) => state.app.appConfig?.config);
  const poaAgreementUUID = _.find(config, (item) => item.key === 'poaAgreementUUID')?.value;
  const commissionRateLandlord = useAppConfig()?.commissionRateLandlord;
  const [saleDetail, setSaleDetail] = useState(null);
  const isBuyer = user?.role === 'AGENCY' && user?.agency?.agencyId === saleDetail?.buyerId;
  useEffect(() => {
    if (saleId) {
      requestGetSaleDetail(saleId);
    }
  }, [saleId]);
  const [premiseDetail, setPremiseDetail] = useState();
  useEffect(() => {
    if (saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD && saleDetail?.premiseId) {
      getPremiseDetail(saleDetail?.premiseId);
    }
  }, [saleDetail]);
  const getPremiseDetail = (id) => {
    AgencyHelper.API.requestGetPremiseDetail(id).then((data) => {
      if (data && Object.keys(data)?.length > 0) {
        setPremiseDetail(data);
      }
    });
  };
  const operatorList = useSelector((state) => state?.app?.appConfig?.operators) ?? [];
  const [saleOperatorDetail, setSaleOperatorDetail] = useState(null);
  useEffect(() => {
    if (saleDetail) {
      const operatorId = saleDetail?.operatorId;
      const operator = operatorList.find((item) => item.operatorId === operatorId);
      setSaleOperatorDetail(operator);
    }
  }, [saleDetail, operatorList]);
  const [contractList, setContractList] = useState([]);
  const activeContract = useMemo(() => {
    return saleDetail?.contracts?.find(
      (item) => item.status !== AgencyConstants.ContractStatus.CANCELLED
    );
  }, [saleDetail]);
  const [acceptanceReportList, setAcceptanceReportList] = useState([]);
  const activeAcceptanceReport = useMemo(() => {
    return acceptanceReportList?.find(
      (item) => item.status !== AgencyConstants.AcceptanceStatus.CANCELLED
    );
  }, [acceptanceReportList]);
  useEffect(() => {
    if (saleDetail) {
      // const buyerId = saleDetail?.buyerId;
      // const saleId = saleDetail?.saleId;
      // requestGetSaleContractList(saleId, buyerId);
      setContractList(saleDetail?.contracts ?? []);
      setAcceptanceReportList(saleDetail?.acceptanceReports ?? []);
    }
  }, [saleDetail]);
  const contractColumns = useMemo(() => {
    return [
      {
        name: UIHelper.buildTableColumn("Mã hợp đồng"),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              if (Utils.isValid(row?.contractDocument) && (isAdmin || isBuyer)) {
                handleViewContract(row);
              }
            }}
          >
            {row?.contractCode ?? row?.contractId}
          </span>
        ),
        minWidth: '180px',
        style: (isAdmin || isBuyer) ? tableStyle.columns.link : tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Mẫu hợp đồng"),
        selector: (row) => AgencyHelper.Utils.getContractRoleName(row?.contractRole),
        width: '220px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Loại hợp đồng"),
        selector: (row) =>
          _.find(AgencyHelper.Data.contractTypeOptions, (item) => item.value === row?.contractType)
            ?.name,
        width: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Số hợp đồng"),
        selector: (row) => row?.contractNumber,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Ngày hợp đồng"),
        selector: (row) => Utils.formatDateTimeToString(row?.contractDate, 'DD/MM/YYYY'),
        minWidth: '120px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Ngày hiệu lực"),
        selector: (row) => Utils.formatDateTimeToString(row?.validFrom, 'DD/MM/YYYY'),
        minWidth: '120px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Ngày hết hạn"),
        selector: (row) => Utils.formatDateTimeToString(row?.validTo, 'DD/MM/YYYY'),
        minWidth: '120px',
        style: tableStyle.columns.normal,
        omit: saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR,
      },
      {
        name: UIHelper.buildTableColumn("Giấy uỷ quyền"),
        selector: (row) => {
          return row?.poaDocument ? (
            <span
              className="hover-opacity-60 cursor-pointer"
              onClick={() => {
                Utils.openInNewTab(Utils.getFullUrl(row?.poaDocument));
              }}
            >
              Xem chi tiết
            </span>
          ) : (
            <></>
          );
        },
        minWidth: '140px',
        style: tableStyle.columns.link,
        omit: saleDetail?.orderType !== AgencyConstants.SaleOrderType.GROUP,
      },
      {
        name: UIHelper.buildTableColumn("Trạng thái"),
        selector: (row) => (
          <KTLabel
            text={AgencyHelper.Utils.getContractStatusName(row?.status)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${AgencyHelper.Utils.getContractStatusColor(
              row?.status
            )}`}
            additionalDescription={row?.cancelingReason}
          />
        ),
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Tệp đính kèm"),
        selector: (row) => {
          return row?.attachedFiles?.length > 0 ? (
            <span
              className="hover-opacity-60 cursor-pointer"
              onClick={() => {
                handleViewFiles(row?.attachedFiles);
              }}
            >
              {`Xem chi tiết (${row?.attachedFiles?.length})`}
            </span>
          ) : (
            <></>
          );
        },
        minWidth: '140px',
        style: tableStyle.columns.link,
      },
      {
        name: UIHelper.buildTableColumn("Phụ lục hợp đồng"),
        selector: (row) => {
          return row?.appendices?.length > 0 ? (
            <span
              className="hover-opacity-60 cursor-pointer"
              onClick={() => {
                handleShowAppendicesList(row?.appendices, row?.contractId);
              }}
            >
              {`Phụ lục (${row?.appendices?.length})`}
            </span>
          ) : (
            <></>
          );
        },
        minWidth: '140px',
        style: tableStyle.columns.link,
      },
      {
        name: UIHelper.buildTableColumn("Ngày tạo"),
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt),
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn("Thao tác"),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        center: false,
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActionsContract(row), true);
        },
        omit: !isAdmin && !isBuyer,
      },
    ];
  }, [user, saleDetail, isSale, isBuyer, isAdmin]);
  const [creatingContract, setCreatingContract] = useState(false);
  const acceptanceReportColumns = useMemo(() => {
    return [
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Mã biên bản
          </span>
        ),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              if (Utils.isValid(row?.document) && (isAdmin || isAdminMaintainer || isBuyer)) {
                Utils.openInNewTab(Utils.getFullUrl(row?.document));
              }
            }}
          >
            {row?.acceptanceCode ?? row?.acceptanceId}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Mẫu biên bản
          </span>
        ),
        selector: (row) => AgencyHelper.Utils.getAcceptanceRoleName(row?.acceptanceType),
        width: '220px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Loại biên bản
          </span>
        ),
        selector: (row) =>
          _.find(AgencyHelper.Data.acceptanceTypeOptions, (item) => item.value === row?.documentType)
            ?.name,
        width: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Số biên bản
          </span>
        ),
        selector: (row) => row?.number,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Ngày biên bản
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY'),
        minWidth: '120px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Ngày hiệu lực
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY'),
        minWidth: '120px',
        style: tableStyle.columns.normal,
      },
      // {
      //   name: (
      //     <span
      //       className="letter-spacing-unset"
      //       style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
      //     >
      //       Ngày hết hạn
      //     </span>
      //   ),
      //   selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY'),
      //   minWidth: '120px',
      //   style: tableStyle.columns.normal,
      //   omit: saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR,
      // },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Trạng thái
          </span>
        ),
        selector: (row) => (
          <KTLabel
            text={AgencyHelper.Utils.getAcceptanceStatusName(row?.status, row?.acceptanceType)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${AgencyHelper.Utils.getAcceptanceStatusColor(
              row?.status
            )}`}
            additionalDescription={row?.cancelingReason}
          />
        ),
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Tệp đính kèm
          </span>
        ),
        selector: (row) => {
          return row?.attachedFiles?.length > 0 ? (
            <span
              className="hover-opacity-60 cursor-pointer"
              onClick={() => {
                handleViewFiles(row?.attachedFiles);
              }}
            >
              {`Xem chi tiết (${row?.attachedFiles?.length})`}
            </span>
          ) : (
            <></>
          );
        },
        minWidth: '140px',
        style: tableStyle.columns.link,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Ngày tạo
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt),
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Thao tác
          </span>
        ),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        center: false,
        omit: isSale,
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActionsAcceptance(row), true);
        },
      },
    ];
  }, [user, saleDetail, isSale]);
  const [creatingAcceptanceReport, setCreatingAcceptanceReport] = useState(false);

  const technicalAcceptance = useMemo(() => {
    if (!saleDetail) return null;
    return saleDetail?.acceptanceReports?.find(
      (acceptance) => acceptance?.acceptanceType === AgencyConstants.AcceptanceRole.TECHNICAL && acceptance?.status !== AgencyConstants.AcceptanceStatus.CANCELLED
    ) || null;
  }, [saleDetail]);

  const financialAcceptance = useMemo(() => {
    if (!saleDetail) return null;
    return saleDetail?.acceptanceReports?.find(
      (acceptance) => acceptance?.acceptanceType === AgencyConstants.AcceptanceRole.FINANCIAL && acceptance?.status !== AgencyConstants.AcceptanceStatus.CANCELLED
    ) || null;
  }, [saleDetail]);

  const saleModelItemsWithQuantity = useMemo(() => {
    const items = [];
    const inventoryItems = [];

    if (Array.isArray(saleDetail?.items) && saleDetail.items.length > 0) {
      const mappedItems = saleDetail.items.map((item) => ({
        modelId: item?.modelId,
        brandId: item?.chargeModel?.brandId,
        amount: item?.amountBeforeTax,
        serialNumber: item?.serialNumber,
        serial: item?.serialNumber,
        model: item?.chargeModel?.name,
        type: item?.chargeModel?.type,
        connectorType: item?.chargeModel?.connectorType,
        unit: 'Trụ',
        taxRate: Math.round(item?.taxRate * 100),
        productType: 'CHARGE_MODEL',
      }));

      items.push(
        ...mappedItems.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.modelId === item.modelId && i.amount === item.amount && i.taxRate === item.taxRate);
          if (existingItem) {
            existingItem.quantity = (existingItem.quantity || 0) + 1;
          } else {
            acc.push({ ...item, quantity: 1 });
          }
          return acc;
        }, [])
      );
    }

    if (Array.isArray(saleDetail?.inventoryItems) && saleDetail.inventoryItems.length > 0) {
      inventoryItems.push(
        ...saleDetail.inventoryItems.map((inventoryItem) => ({
          modelId: inventoryItem?.categoryId,
          amount: inventoryItem?.priceBeforeTax,
          model: inventoryItem?.name,
          quantity: inventoryItem?.quantity,
          unit: inventoryItem?.category?.unit,
          taxRate: Math.round(inventoryItem?.taxRate * 100),
          productType: 'INVENTORY',
        }))
      );
    }

    return [...items, ...inventoryItems];
  }, [saleDetail]);

  const taxAmount = useMemo(() => {
    if (financialAcceptance?.items?.taxAmount != null) {
      return financialAcceptance.items.taxAmount;
    }

    if (!saleModelItemsWithQuantity || saleModelItemsWithQuantity.length === 0) {
      return 0;
    }

    return saleModelItemsWithQuantity.reduce((sum, item) => {
      if (item?.taxRate != null && item?.amount != null && item?.quantity != null) {
        return sum + Math.round(item.amount * item.quantity * item.taxRate / 100);
      }
      return sum;
    }, 0);
  }, [financialAcceptance?.items?.taxAmount, saleModelItemsWithQuantity]);

  const otherAmount = useMemo(() =>
    saleDetail?.amountAfterTax - (saleDetail?.amount + taxAmount + saleDetail?.serviceAmount)
    , [saleDetail, taxAmount])

  const [technicalDialogSize, setTechnicalDialogSize] = useState('xl');
  const [financialDialogSize, setFinancialDialogSize] = useState('xl');

  useEffect(() => {
    const handleUpdateSale = async () => {
      if (isAdmin && financialAcceptance
        && financialAcceptance?.status === AgencyConstants.AcceptanceStatus.COMPLETED
        && activeContract?.status === AgencyConstants.ContractStatus.COMPLETED
        && saleDetail?.status !== AgencyConstants.SaleOrderStatus.COMPLETED
      ) {
        const result = await AgencyHelper.API.requestUpdateSale(saleId, {
          status: AgencyConstants.SaleOrderStatus.COMPLETED,
        });
        requestGetSaleDetail(saleId);
      }
    }
    handleUpdateSale();
  }, [financialAcceptance, isAdmin])

  useEffect(() => {
    const handleUpdateSale = async () => {
      if (isAdmin && activeContract
        && saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR
        && activeContract?.status === AgencyConstants.ContractStatus.COMPLETED
        && saleDetail?.status !== AgencyConstants.SaleOrderStatus.PAID
        && !technicalAcceptance
      ) {
        const result = await AgencyHelper.API.requestUpdateSale(saleId, {
          status: AgencyConstants.SaleOrderStatus.PAID,
        });
        requestGetSaleDetail(saleId);
      }
    }
    handleUpdateSale();
  }, [activeContract, isAdmin, saleDetail, technicalAcceptance])

  useEffect(() => {
    const handleUpdateSale = async () => {
      if (isAdmin && technicalAcceptance
        && saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR
        && technicalAcceptance?.status === AgencyConstants.AcceptanceStatus.COMPLETED
        && activeContract?.status === AgencyConstants.ContractStatus.COMPLETED
        && saleDetail?.status !== AgencyConstants.SaleOrderStatus.COMPLETED
      ) {
        const result = await AgencyHelper.API.requestUpdateSale(saleId, {
          status: AgencyConstants.SaleOrderStatus.COMPLETED,
        });
        requestGetSaleDetail(saleId);
      }
    }
    handleUpdateSale();
  }, [technicalAcceptance, isAdmin, saleDetail])

  const showAcceptanceList = useMemo(() => {
    return (
      saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR &&
      [
        AgencyConstants.SaleOrderStatus.PAID,
        AgencyConstants.SaleOrderStatus.INSTALLED,
        AgencyConstants.SaleOrderStatus.COMPLETED,
      ].includes(saleDetail?.status)
    )
      || (
        saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR &&
        [
          AgencyConstants.ContractStatus.COMPLETED,
        ].includes(activeContract?.status)
      )
      || (saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD &&
        [
          AgencyConstants.SaleOrderStatus.PAID,
          AgencyConstants.SaleOrderStatus.INSTALLED,
          AgencyConstants.SaleOrderStatus.COMPLETED,
        ].includes(saleDetail?.status) &&
        [
          AgencyConstants.ContractStatus.AGENCY_SIGNED,
          AgencyConstants.ContractStatus.COMPLETED,
        ].includes(activeContract?.status)
      )
  }, [saleDetail])

  // MARK: ---- FUNCTIONS ----
  const requestGetSaleDetail = async (saleId) => {
    const sale = await AgencyHelper.API.requestGetSaleDetail(saleId);
    if (sale) {
      setSaleDetail(sale);
    }
  };
  const requestGetSaleContractList = async (saleId, agencyId) => {
    if (isAdmin || !isSale) {
      const contracts = await AgencyHelper.API.requestGetContractList({
        agencyId,
        saleId,
      });
      if (contracts) {
        setContractList(contracts);
      }
    }
  };
  const buildMoreActionsSaleOrder = (row) => {
    const contract = _.first(saleDetail?.contracts);
    const isMine = user?.userId === row?.userId;
    const isSeller = user?.agency?.agencyId === row?.agencyId;
    const actions = [];

    if (Utils.checkPermission(permissionList, AppConstants.permissionCode.orderUpdate.code)) {
      if (isAdmin || (isMine || isSeller))
        actions.push({
          text: 'Chỉnh sửa',
          iconElement: <i className="fa-regular fa-edit" />,
          click: () => {
            router.navigate(`edit`);
          },
        });
      if (
        isAdmin &&
        (row?.orderType === AgencyConstants.SaleOrderType.GROUP &&
          row?.status === AgencyConstants.SaleOrderStatus.ORDERED)
      )
        actions.push({
          text: 'Duyệt thanh toán',
          iconElement: <i className="fa-regular fa-sack-dollar" />,
          click: () => {
            handleUpdateSaleOrderPaid(row);
          },
        });
      if (
        isAdmin &&
        (row?.orderType === AgencyConstants.SaleOrderType.INVESTOR &&
          row?.status === AgencyConstants.SaleOrderStatus.ORDERED &&
          contract?.status === AgencyConstants.ContractStatus.COMPLETED)
      )
        actions.push({
          text: 'Duyệt tạm ứng',
          iconElement: <i className="fa-regular fa-sack-dollar" />,
          click: () => {
            handleUpdateSaleOrderPaid(row);
          },
        });
      // huy don hang
      if (
        (isAdmin && row?.status !== AgencyConstants.SaleOrderStatus.CANCELLED
          || (isSeller || isMine) && row?.status === AgencyConstants.SaleOrderStatus.ORDERED && !row?.contracts?.length)
        && Utils.checkPermission(permissionList, AppConstants.permissionCode.orderDelete.code)
        // &&
        // [
        //   AgencyConstants.SaleOrderStatus.ORDERED,
        //   AgencyConstants.SaleOrderStatus.SHIPPING,
        //   AgencyConstants.SaleOrderStatus.INSTALLING,
        //   AgencyConstants.SaleOrderStatus.INSTALLED,
        //   AgencyConstants.SaleOrderStatus.PAID,
        // ].includes(row?.status)
      ) {
        actions.push({
          text: 'Hủy đơn hàng',
          iconElement: (
            <i
              className="fa-regular fa-times-circle"
              style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
            />
          ),
          click: () => {
            AppCustomDialogHelper.show(
              '',
              <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
                title="Hủy đơn hàng"
                contentEl={
                  <>
                    Bạn có chắc muốn hủy đơn hàng:{' '}
                    <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                      {row?.saleCode ?? row?.saleId}
                    </span>
                    ?
                  </>
                }
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={async () => {
                  // const uncancelledContract = row?.contracts?.find(contract => contract?.status !== AgencyConstants.ContractStatus.CANCELLED);
                  // if (!!uncancelledContract) {
                  //   if (uncancelledContract?.status === AgencyConstants.ContractStatus.EXPIRED) {
                  //     ToastHelper.showError(`Không thể hủy đơn hàng vì tồn tại hợp đồng ${uncancelledContract?.contractNumber} đã hết hạn`)
                  //   } else {
                  //     ToastHelper.showError(`Không thể hủy đơn hàng vì tồn tại hợp đồng ${uncancelledContract?.contractNumber} đang chạy`)
                  //   }
                  // } else {
                  AppCustomDialogHelper.hide();
                  let updateProductSuccess = true;
                  let updateContractSuccess = true;
                  if (row?.orderType === AgencyConstants.SaleOrderType.LANDLORD) {
                    updateProductSuccess = await AgencyHelper.API.requestUpdatePremise(
                      row?.premise?.premiseId,
                      Utils.transformEmptyStrings({
                        agencyId: null,
                      })
                    );
                    if (!updateProductSuccess) {
                      ToastHelper.showError(`Cập nhật thông tin mặt bằng không thành công`);
                    }
                  }
                  const uncancelledContract = row?.contracts?.find(contract => contract?.status !== AgencyConstants.ContractStatus.CANCELLED);
                  if (!!uncancelledContract) {
                    updateContractSuccess = await AgencyHelper.API.requestUpdateContract(uncancelledContract?.contractId, {
                      status: AgencyConstants.ContractStatus.CANCELLED,
                      cancelingReason: "Hủy đơn hàng",
                    });
                    if (!updateContractSuccess) {
                      ToastHelper.showError(`Cập nhật trạng thái hợp đồng không thành công`);
                    }
                  }
                  if (updateProductSuccess && updateContractSuccess) {
                    const result = await AgencyHelper.API.requestUpdateSale(row?.saleId, {
                      status: AgencyConstants.SaleOrderStatus.CANCELLED,
                    });
                    if (result && _.isBoolean(result)) {
                      ToastHelper.showSuccess('Hủy đơn hàng thành công');
                      requestGetSaleDetail(row?.saleId);
                    } else {
                      ToastHelper.showError('Hủy đơn hàng thất bại');
                    }
                  }
                  // }
                }}
              />,
              'md',
              false,
              true
            );
          },
        });
      }
    }
    if (Utils.checkPermission(permissionList, AppConstants.permissionCode.orderDelete.code)) {
      if (
        (isAdmin || isMine || isSeller) &&
        (row?.status === AgencyConstants.SaleOrderStatus.ORDERED && !Utils.isValid(contract))
        && Utils.checkPermission(permissionList, AppConstants.permissionCode.orderDelete.code)
      )
        actions.push({
          text: 'Xóa đơn hàng',
          iconElement: <i className="fa-regular fa-trash-can" />,
          click: () => {
            AppCustomDialogHelper.show(
              '',
              <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
                title="Xóa đơn hàng"
                contentEl={
                  <>
                    Bạn có chắc muốn xóa đơn hàng:{' '}
                    <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                      {row?.saleCode ?? row?.saleId}
                    </span>
                    ?
                  </>
                }
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={async () => {
                  AppCustomDialogHelper.hide();
                  const result = await AgencyHelper.API.requestDeleteSale(row?.saleId);
                  let isResetPremiseSuccess = true;
                  isResetPremiseSuccess = await AgencyHelper.API.requestUpdatePremise(
                    saleDetail?.premise?.premiseId,
                    Utils.transformEmptyStrings({
                      agencyId: ''
                    })
                  );
                  if (result && _.isBoolean(result) && isResetPremiseSuccess) {
                    ToastHelper.showSuccess('Xoá đơn hàng thành công');
                    router.navigate(-1);
                  } else {
                    ToastHelper.showError(result || 'Xoá đơn hàng thất bại');
                  }
                }}
              />,
              'md',
              false,
              true
            );
          },
        });
    }

    return actions;
  };
  const handleViewContract = (row) => {
    if (!Utils.isValid(row?.contractDocument)) return;

    const token = user?.token;
    let url = Utils.getFullUrl(row.contractDocument);

    if (token) {
      url += (url.includes('?') ? '&' : '?') + `token=${token}`;
    }

    Utils.openInNewTab(url);
  }
  const buildMoreActionsContract = (row) => {
    const actions = [];
    actions.push({
      text: 'Xem chi tiết',
      iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
      click: () => handleViewContract(row),
    });
    if (isAdmin) {
      // ky hop dong
      if (row?.status === AgencyConstants.ContractStatus.CREATED) {
        actions.push({
          text: 'Ký hợp đồng',
          iconElement: (
            <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />
          ),
          click: () => {
            handleSignContract(row);
          },
        });
      }
      if (row?.contractType === AgencyConstants.ContractType.DIGITAL && row?.status === AgencyConstants.ContractStatus.CREATED
        || row?.contractType === AgencyConstants.ContractType.PAPER
      ) {
        // chinh sua
        actions.push({
          text: 'Chỉnh sửa',
          iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            AppCustomDialogHelper.show(
              'Chỉnh sửa hợp đồng',
              <AgencyContractEditView
                contractDetail={row}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={() => {
                  AppCustomDialogHelper.hide();
                  requestGetSaleDetail(saleId);
                }}
              />,
              'md',
              false,
              true
            );
          },
        });
      }
      if (row?.status === AgencyConstants.ContractStatus.COMPLETED) {
        actions.push({
          text: 'Tạo phụ lục hợp đồng',
          iconElement: <i className="fa-regular fa-plus" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            AppCustomDialogHelper.show(
              '',
              <AgencySaleCreateAppendixView
                title={"Tạo phụ lục hợp đồng"}
                appendicesList={row?.appendices}
                contentEl={
                  <>
                    Bạn muốn tạo phụ lục hợp đồng cho{' '}
                    <span>
                      {AgencyHelper.Utils.getContractRoleName(row?.contractRole).toLocaleLowerCase()}
                    </span>
                    {' '} số {' '}
                    <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                      {row?.contractNumber}
                    </span>
                    ?
                  </>
                }
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={async (param) => {
                  let currentAppendices = row?.appendices || [];
                  const updatedAppendices = Array.isArray(param)
                    ? [...currentAppendices, ...param]
                    : [...currentAppendices, param];
                  const result = await AgencyHelper.API.requestUpdateContract(
                    row?.contractId,
                    {
                      appendices: updatedAppendices
                    }
                  );
                  if (_.isObject(result)) {
                    ToastHelper.showSuccess('Tạo phụ lục hợp đồng thành công');
                    requestGetSaleDetail(saleDetail?.saleId);
                    AppCustomDialogHelper.hide();
                  } else {
                    ToastHelper.showError(result || 'Tạo phụ lục hợp đồng không thành công');
                  }
                  return false;
                }}
              />,
              'lg',
              false,
              true
            );
          },
        });
      }
      if (
        row?.status !== AgencyConstants.ContractStatus.CANCELLED
      ) {
        actions.push({
          text: 'Hủy hợp đồng',
          iconElement: <i className="fa-regular fa-circle-xmark" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            AppCustomDialogHelper.show(
              '',
              <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
                title="Hủy hợp đồng"
                contentEl={
                  <>
                    Nhập lý do hủy hợp đồng {' '}
                    <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                      {row?.contractNumber}
                    </span>
                  </>
                }
                inputLabel={['Lý do']}
                showInput={true}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={async (values) => {
                  const [cancelingReason] = values;
                  AppCustomDialogHelper.hide();
                  const result = await AgencyHelper.API.requestUpdateContract(row?.contractId, {
                    status: AgencyConstants.ContractStatus.CANCELLED,
                    cancelingReason: cancelingReason,
                  });
                  const updateOrderResult = await AgencyHelper.API.requestUpdateSale(row?.saleId, {
                    status: AgencyConstants.SaleOrderStatus.CANCELLED,
                  });
                  if (result && _.isObject(result) && updateOrderResult && _.isBoolean(updateOrderResult)) {
                    ToastHelper.showSuccess('Hủy hợp đồng thành công');
                    requestGetSaleDetail(saleId);
                  } else {
                    ToastHelper.showError('Hủy hợp đồng thất bại');
                  }
                }}
                confirmButtonRed={true}
              />,
              'md',
              false,
              true
            );
          },
        });
      }
      if (row?.status === AgencyConstants.ContractStatus.CREATED) {
        actions.push({
          text: 'Xoá hợp đồng',
          iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            AppCustomDialogHelper.show(
              '',
              <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
                title="Xoá hợp đồng"
                contentEl={
                  <>
                    Bạn có chắc muốn xoá hợp đồng:{' '}
                    <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                      {row?.contractNumber}
                    </span>
                    ?
                  </>
                }
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onConfirm={async () => {
                  AppCustomDialogHelper.hide();
                  const result = await AgencyHelper.API.requestDeleteContract(row?.contractId);
                  if (result && _.isBoolean(result)) {
                    ToastHelper.showSuccess('Xoá hợp đồng thành công');
                    requestGetSaleDetail(saleId);
                  } else {
                    ToastHelper.showError(result || 'Xoá hợp đồng thất bại');
                  }
                }}
              />,
              'md',
              false,
              true
            );
          },
        });
      }
    } else if (isBuyer) {
      if (row?.status === AgencyConstants.ContractStatus.ADMIN_SIGNED) {
        actions.push({
          text: 'Ký hợp đồng',
          iconElement: (
            <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />
          ),
          click: () => {
            handleSignContract(row);
          },
        });
      }
    }
    return actions;
  };

  const createEditTechnicalAction = (row) => ({
    text: 'Chỉnh sửa',
    iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
    click: () => {
      AppCustomDialogHelper.show(
        'Chỉnh sửa biên bản',
        <AgencySaleCreateTechnicalAcceptanceView
          acceptanceDetail={row}
          saleDetail={saleDetail}
          onCancel={AppCustomDialogHelper.hide}
          onConfirm={async (param) => {
            try {
              let acceptanceReportParam = param;
              if (param?.documentType === AgencyConstants.AcceptanceType.PAPER) {
                // acceptanceReportParam = _.omit(acceptanceReportParam, ['attachedFiles']);
              }

              const result = await AgencyHelper.API.requestUpdateAcceptanceReport(
                row?.acceptanceId,
                acceptanceReportParam
              );

              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Cập nhật biên bản nghiệm thu thành công');
                AppCustomDialogHelper.hide();
                saleDetail && requestGetSaleDetail(saleId);
              } else {
                ToastHelper.showError(result || 'Cập nhật biên bản nghiệm thu thất bại');
              }
            } catch {
              ToastHelper.showError('Có lỗi xảy ra khi cập nhật biên bản nghiệm thu');
            }
            return false;
          }}
        />,
        'xl',
        false,
        true
      );
    },
  });

  const createCancelAction = (row) => ({
    text: 'Hủy biên bản',
    iconElement: <i className="fa-regular fa-circle-xmark" style={{ fontSize: '1.1rem' }} />,
    click: () => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
          title="Hủy biên bản"
          contentEl={
            <>
              Nhập lý do hủy biên bản{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                {row?.number}
              </span>
            </>
          }
          inputLabel={['Lý do']}
          showInput={true}
          onCancel={AppCustomDialogHelper.hide}
          onConfirm={async (values) => {
            const [cancelingReason] = values;
            const result = await AgencyHelper.API.requestUpdateAcceptanceReport(
              row?.acceptanceId,
              {
                status: AgencyConstants.AcceptanceStatus.CANCELLED,
                cancelingReason: cancelingReason,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Hủy biên bản thành công');
              requestGetSaleDetail(saleId);
              AppCustomDialogHelper.hide();
            } else {
              ToastHelper.showError(result || 'Hủy biên bản thất bại');
            }
          }}
          confirmButtonRed
        />,
        'md',
        false,
        true
      );
    },
  });

  const createDeleteAction = (row) => ({
    text: 'Xoá biên bản',
    iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
    click: () => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá biên bản"
          contentEl={
            <>
              Bạn có chắc muốn xoá biên bản:{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                {row?.number}
              </span>
              ?
            </>
          }
          onCancel={AppCustomDialogHelper.hide}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await AgencyHelper.API.requestDeleteAcceptanceReport(row?.acceptanceId);
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá biên bản thành công');
              requestGetSaleDetail(saleId);
            } else {
              ToastHelper.showError(result || 'Xoá biên bản thất bại');
            }
          }}
          confirmButtonRed
        />,
        'md',
        false,
        true
      );
    },
  });

  const createSignAction = (row) => ({
    text: 'Ký biên bản',
    iconElement: <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />,
    click: () => handleSignAcceptance(row),
  });

  const buildTechnicalActions = (row) => {
    const actions = [];

    switch (row?.status) {
      case AgencyConstants.AcceptanceStatus.CREATED:
        if (isAdminMaintainer) {
          actions.push(createSignAction(row));
        }
        if (isAdminMain || isAdminMaintainer) {
          actions.push(createEditTechnicalAction(row), createCancelAction(row), createDeleteAction(row));
        }
        break;

      case AgencyConstants.AcceptanceStatus.ADMIN_SIGNED:
        if (isAgency) actions.push(createSignAction(row));
        if (isAdminMain) actions.push(createCancelAction(row));
        break;

      case AgencyConstants.AcceptanceStatus.COMPLETED:
        if (isAdminMain && row?.documentType === AgencyConstants.AcceptanceType.PAPER) actions.push(createEditTechnicalAction(row));
        break;

      default:
        break;
    }

    return actions;
  };

  const createEditFinancialAction = (row) => ({
    text: 'Chỉnh sửa',
    iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
    click: () => {
      AppCustomDialogHelper.show(
        'Chỉnh sửa biên bản',
        <AgencySaleCreateFinancialAcceptanceView
          acceptanceDetail={row}
          saleDetail={saleDetail}
          onCancel={AppCustomDialogHelper.hide}
          onConfirm={async (param) => {
            try {
              let acceptanceReportParam = param;
              acceptanceReportParam = _.omit(acceptanceReportParam, ['advance', 'totalAmount']);
              if (param?.documentType === AgencyConstants.AcceptanceType.PAPER) {
                // acceptanceReportParam = _.omit(acceptanceReportParam, ['attachedFiles']);
              }

              let updatedSale = true;
              if (saleDetail?.advance !== param?.advance) {
                updatedSale = await AgencyHelper.API.requestUpdateSale(saleId, { advance: param?.advance });
              }

              if (updatedSale) {
                const result = await AgencyHelper.API.requestUpdateAcceptanceReport(
                  row?.acceptanceId,
                  acceptanceReportParam
                );

                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Cập nhật biên bản nghiệm thu thành công');
                  AppCustomDialogHelper.hide();
                  saleDetail && requestGetSaleDetail(saleId);
                } else {
                  ToastHelper.showError(result || 'Cập nhật biên bản nghiệm thu thất bại');
                }
              }
            } catch {
              ToastHelper.showError('Có lỗi xảy ra khi cập nhật biên bản nghiệm thu');
            }
            return false;
          }}
        />,
        'xl',
        false,
        true
      );
    },
  });

  const buildFinancialActions = (row) => {
    const actions = [];

    switch (row?.status) {
      case AgencyConstants.AcceptanceStatus.CREATED:
        if (isAdmin) {
          actions.push(createSignAction(row), createEditFinancialAction(row), createCancelAction(row), createDeleteAction(row));
        }
        break;

      case AgencyConstants.AcceptanceStatus.ADMIN_SIGNED:
        if (isAgency) actions.push(createSignAction(row));
        if (isAdmin) actions.push(createCancelAction(row));
        break;

      case AgencyConstants.AcceptanceStatus.COMPLETED:
        if (isAdminMain && row?.documentType === AgencyConstants.AcceptanceType.PAPER) actions.push(createEditFinancialAction(row));
        break;

      default:
        break;
    }

    return actions;
  };

  const buildMoreActionsAcceptance = (row) => {
    const actions = [];
    actions.push({
      text: 'Xem chi tiết',
      iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
      click: () => {
        if (Utils.isValid(row?.document)) {
          Utils.openInNewTab(Utils.getFullUrl(row?.document));
        }
      },
    });

    if (row?.acceptanceType === AgencyConstants.AcceptanceRole.TECHNICAL) {
      actions.push(...buildTechnicalActions(row));
    }

    if (row?.acceptanceType === AgencyConstants.AcceptanceRole.FINANCIAL) {
      actions.push(...buildFinancialActions(row));
    }

    return actions;
  };

  const handleCreateContract = () => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleCreateContractView
        saleDetail={saleDetail}
        title={saleDetail?.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT ? "Hợp đồng giấy" : `Tạo hợp đồng ${getContractTitle(saleDetail?.orderType)}`}
        defaultContractType={saleDetail?.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT ? AgencyConstants.ContractType.PAPER : ''}
        contentEl={
          <>
            Bạn muốn tạo hợp đồng {getContractTitle(saleDetail?.orderType)} cho đơn hàng:{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {saleDetail?.saleCode}
            </span>
            ?
          </>
        }
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (param) => {
          const buyerDetail = await DealerHelper.callApiGetAgencyDetail(saleDetail?.buyerId)
          if (param?.contractType === AgencyConstants.ContractType.DIGITAL && !buyerDetail?.hsmAgreementUUID) {
            ToastHelper.showError(`${t(`agencyRoleDropdownTitle_${buyerDetail?.primaryRole}`)} chưa có chữ ký số`)
          } else {
            AppCustomDialogHelper.hide();
            setCreatingContract(true);
            let contract = null;
            if (saleDetail?.orderType === AgencyConstants.SaleOrderType.GROUP) {
              if (!poaAgreementUUID) {
                ToastHelper.showError(`Người nhận ủy quyền chưa có chữ ký số`)
              } else {
                let groupContractParam = {
                  operatorId: saleOperatorDetail?.operatorId,
                  saleId: saleId,
                  ...param,
                };
                groupContractParam = _.omit(groupContractParam, ['shippingAddress']);
                if (param?.contractType === AgencyConstants.ContractType.DIGITAL) {
                  groupContractParam = _.omit(groupContractParam, ['contractDocument', 'poaDocument']);
                } else if (param?.contractType === AgencyConstants.ContractType.PAPER) {
                  groupContractParam = _.omit(groupContractParam, ['attachedFiles']);
                }
                contract = await AgencyHelper.API.requestCreateGroupContract(groupContractParam);
              }
            } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR) {
              let investorContractParam = {
                operatorId: saleOperatorDetail?.operatorId,
                saleId: saleId,
                ..._.omit(param, ['validTo']),
              };
              if (param?.contractType === AgencyConstants.ContractType.DIGITAL) {
                await AgencyHelper.API.requestUpdateSale(saleDetail?.saleId, { shippingAddress: param.shippingAddress });
                investorContractParam = _.omit(investorContractParam, [
                  'contractDocument',
                  'poaDocument',
                  'shippingAddress'
                ]);
              } else if (param?.contractType === AgencyConstants.ContractType.PAPER) {
                investorContractParam = _.omit(investorContractParam, ['attachedFiles', 'shippingAddress']);
              }
              contract = await AgencyHelper.API.requestCreateInvestorContract(investorContractParam);
            } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR) {
              let coinvestorContractParam = {
                operatorId: saleOperatorDetail?.operatorId,
                saleId: saleId,
                ...param,
              };
              if (param?.contractType === AgencyConstants.ContractType.DIGITAL) {
                await AgencyHelper.API.requestUpdateSale(saleDetail?.saleId, { shippingAddress: param.shippingAddress });
                coinvestorContractParam = _.omit(coinvestorContractParam, [
                  'contractDocument',
                  'poaDocument',
                  'shippingAddress'
                ]);
              } else if (param?.contractType === AgencyConstants.ContractType.PAPER) {
                coinvestorContractParam = _.omit(coinvestorContractParam, ['attachedFiles', 'shippingAddress']);
              }
              contract = await AgencyHelper.API.requestCreateCoinvestorContract(coinvestorContractParam);
            } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD) {
              let landlordContractParam = {
                operatorId: saleOperatorDetail?.operatorId,
                saleId: saleId,
                ...param,
              };
              landlordContractParam = _.omit(landlordContractParam, ['shippingAddress']);
              if (param?.contractType === AgencyConstants.ContractType.DIGITAL) {
                landlordContractParam = _.omit(landlordContractParam, [
                  'contractDocument',
                  'poaDocument',
                ]);
              } else if (param?.contractType === AgencyConstants.ContractType.PAPER) {
                landlordContractParam = _.omit(landlordContractParam, ['attachedFiles']);
                landlordContractParam.status = AgencyConstants.ContractStatus.COMPLETED;
                await AgencyHelper.API.requestUpdatePremise(saleDetail?.premise?.premiseId, { status: AgencyConstants.PremiseStatus.RENTED });
              }
              contract = await AgencyHelper.API.requestCreateLandlordContract(landlordContractParam);
            } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT) {
              let chargePointContractParam = {
                operatorId: saleOperatorDetail?.operatorId,
                saleId: saleId,
                ..._.omit(param, ['validTo']),
              };
              chargePointContractParam = _.omit(chargePointContractParam, ['attachedFiles', 'shippingAddress']);
              contract = await AgencyHelper.API.requestCreateChargePointContract(chargePointContractParam);
            }
            if (contract && _.isObject(contract)) {
              ToastHelper.showSuccess('Tạo hợp đồng thành công');
              if (saleDetail) {
                requestGetSaleDetail(saleId);
              }
            } else {
              ToastHelper.showError(contract || 'Tạo hợp đồng thất bại');
            }
            setCreatingContract(false);
          }
        }}
      />,
      'md',
      false,
      true
    );
  };
  const handleSignContract = (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
        title="Ký hợp đồng"
        contentEl={
          <>
            Bạn muốn ký hợp đồng:{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {row?.contractNumber}
            </span>
            ?
          </>
        }
        showInput={!isAdmin}
        inputLabel={['Định danh chữ ký số (UUID)', 'Nhập mật khẩu']}
        inputType={['text', 'password']}
        defaultValue={[user?.agency?.hsmAgreementUUID, '']}
        showAdditionalInfo={!isAdmin && !user?.agency?.hsmAgreementUUID}
        additionalInfo={
          <div
            className="d-flex gap-3 p-3 align-items-center"
            style={{
              border: `1px dashed ${AppColors.danger}`,
              backgroundColor: '#FFF6F6',
            }}
          >
            <div className="w-32px h-32px rounded-circle bg-danger-o-20 d-flex align-items-center justify-content-center">
              <i className="fas fa-signature" style={{ color: AppColors.danger }} />
            </div>
            <div className="d-flex flex-column">
              <div style={UIHelper.buildFontStyle('700', '20px', AppColors.danger)}>
                Bạn chưa có chữ ký số?
              </div>
              <div>
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                  Vui lòng tạo chữ ký số{' '}
                </span>
                <a
                  href={'#'}
                  target={'_blank'}
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.danger)}
                >
                  tại đây
                </a>
              </div>
            </div>
          </div>
        }
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (values) => {
          let contract = null;
          if (isAdmin) {
            contract = await AgencyHelper.API.requestAdminSignContract(row?.contractId);
          } else {
            const [hsmAgreementUUID, hsmPassword] = values;
            contract = await AgencyHelper.API.requestAgencySignContract(
              row?.contractId,
              hsmAgreementUUID,
              hsmPassword
            );
          }
          if (contract && _.isObject(contract)) {
            AppCustomDialogHelper.hide();
            ToastHelper.showSuccess('Ký hợp đồng thành công');
            requestGetSaleDetail(saleId);
          } else {
            ToastHelper.showError(contract || 'Ký hợp đồng thất bại');
          }
        }}
      />,
      'md',
      false,
      true
    );
  };

  const handleSignAcceptance = (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
        title="Ký biên bản"
        contentEl={
          <>
            Bạn muốn ký biên bản:{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {row?.number}
            </span>
            ?
          </>
        }
        showInput={true}
        inputLabel={['Định danh chữ ký số (UUID)', 'Nhập mật khẩu']}
        inputType={['text', 'password']}
        defaultValue={[user?.agency?.hsmAgreementUUID, '']}
        showAdditionalInfo={!isAdmin && !user?.agency?.hsmAgreementUUID}
        additionalInfo={
          <div
            className="d-flex gap-3 p-3 align-items-center"
            style={{
              border: `1px dashed ${AppColors.danger}`,
              backgroundColor: '#FFF6F6',
            }}
          >
            <div className="w-32px h-32px rounded-circle bg-danger-o-20 d-flex align-items-center justify-content-center">
              <i className="fas fa-signature" style={{ color: AppColors.danger }} />
            </div>
            <div className="d-flex flex-column">
              <div style={UIHelper.buildFontStyle('700', '20px', AppColors.danger)}>
                Bạn chưa có chữ ký số?
              </div>
              <div>
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                  Vui lòng tạo chữ ký số{' '}
                </span>
                <a
                  href={'#'}
                  target={'_blank'}
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.danger)}
                >
                  tại đây
                </a>
              </div>
            </div>
          </div>
        }
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (values) => {
          const [hsmAgreementUUID, hsmPassword] = values;
          AppCustomDialogHelper.hide();
          let acceptanceReport = null;
          if (isAdmin) {
            if (row?.acceptanceType === AgencyConstants.AcceptanceRole.TECHNICAL) {
              acceptanceReport = await AgencyHelper.API.requestAdminSignTechnicalAcceptance({
                acceptanceId: row?.acceptanceId,
                hsmPasscode: hsmPassword,
              });
            } else {
              acceptanceReport = await AgencyHelper.API.requestAdminSignFinancialAcceptance({
                acceptanceId: row?.acceptanceId,
                hsmPasscode: hsmPassword,
              });
            }
          } else {
            acceptanceReport = await AgencyHelper.API.requestAgencySignAcceptance({
              acceptanceId: row?.acceptanceId,
              hsmPasscode: hsmPassword,
            });
            if (row?.acceptanceType === AgencyConstants.AcceptanceRole.TECHNICAL) {
              const station = await ChargeHelper.API.getChargeStationDetail(row?.stationId);
              if (station?.status !== 'NORMAL') {
                const result = await ChargeHelper.API.requestUpdateChargeStation(row?.stationId, { status: 'NORMAL' });
                if (!_.isBoolean(result) || result !== true) {
                  ToastHelper.showError(result || 'Cập nhật trạm sạc không thành công');
                  return;
                }
              }
            }
          }
          if (acceptanceReport && _.isObject(acceptanceReport)) {
            ToastHelper.showSuccess('Ký biên bản thành công');
            requestGetSaleDetail(saleId);
          } else {
            ToastHelper.showError(acceptanceReport || 'Ký biên bản thất bại');
          }
        }}
      />,
      'md',
      false,
      true
    );
  };

  const handleSetTechnicalDialogSize = (documentType) => {
    const size = documentType === AgencyConstants.AcceptanceType.PAPER ? 'md' : 'xl';
    setTechnicalDialogSize(size);

    setTimeout(() => {
      handleCreateTechnicalAcceptanceReport(size);
    }, 0);
  };

  const handleCreateTechnicalAcceptanceReport = (size = technicalDialogSize) => {
    return AppCustomDialogHelper.show(
      '',
      <AgencySaleCreateTechnicalAcceptanceView
        saleDetail={saleDetail}
        title="Tạo biên bản nghiệm thu kỹ thuật"
        contentEl={
          <>
            Bạn muốn tạo biên bản nghiệm thu kỹ thuật cho đơn hàng:{' '}
            <span
              style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
            >
              {saleDetail?.saleCode}
            </span>
            ?
          </>
        }
        onSetDialogSize={handleSetTechnicalDialogSize}
        loading={creatingAcceptanceReport}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (param) => {
          setCreatingAcceptanceReport(true);
          try {
            let acceptanceReportParam = param;
            const acceptanceReport =
              await AgencyHelper.API.requestCreateAcceptanceReport(acceptanceReportParam);

            if (acceptanceReport && _.isObject(acceptanceReport)) {
              ToastHelper.showSuccess('Tạo biên bản nghiệm thu thành công');
              AppCustomDialogHelper.hide();
              if (saleDetail) {
                requestGetSaleDetail(saleId);
              }
            } else {
              ToastHelper.showError(acceptanceReport || 'Tạo biên bản nghiệm thu thất bại');
              return false;
            }
          } catch (e) {
            ToastHelper.showError('Có lỗi xảy ra khi tạo biên bản nghiệm thu');
          } finally {
            setCreatingAcceptanceReport(false);
          }
        }}
      />,
      'xl',
      false,
      true
    );
  };

  const handleSetFinancialDialogSize = (documentType) => {
    const size = documentType === AgencyConstants.AcceptanceType.PAPER ? 'md' : 'xl';
    setFinancialDialogSize(size);

    setTimeout(() => {
      handleCreateFinancialAcceptanceReport(size);
    }, 0);
  };

  const handleCreateFinancialAcceptanceReport = (size = financialDialogSize) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleCreateFinancialAcceptanceView
        saleDetail={saleDetail}
        technicalAcceptance={technicalAcceptance}
        title={"Tạo biên bản nghiệm thu thanh toán"}
        contentEl={
          <>
            Bạn muốn tạo biên bản nghiệm thu thanh toán cho đơn hàng:{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {saleDetail?.saleCode}
            </span>
            ?
          </>
        }
        onSetDialogSize={handleSetFinancialDialogSize}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (param) => {
          setCreatingAcceptanceReport(true);
          try {
            let acceptanceReportParam = param;
            acceptanceReportParam = _.omit(acceptanceReportParam, ['advance', 'totalAmount']);
            if (param?.documentType === AgencyConstants.AcceptanceType.PAPER) {
              acceptanceReportParam = _.omit(acceptanceReportParam, ['attachedFiles']);
            }

            const acceptanceReport = await AgencyHelper.API.requestCreateAcceptanceReport(acceptanceReportParam);

            if (acceptanceReport && _.isObject(acceptanceReport)) {
              ToastHelper.showSuccess('Tạo biên bản nghiệm thu thành công');
              AppCustomDialogHelper.hide();
              if (saleDetail) {
                requestGetSaleDetail(saleId);
              }
            } else {
              ToastHelper.showError(acceptanceReport || 'Tạo biên bản nghiệm thu thất bại');
            }
          } catch (e) {
            ToastHelper.showError('Có lỗi xảy ra khi tạo biên bản nghiệm thu');
          } finally {
            setCreatingAcceptanceReport(false);
          }
        }}
      />,
      'xl',
      false,
      true
    );
  };
  const handleUpdateSaleOrderPaid = async (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogUpdateOrder} />}
        title="Cập nhật đơn hàng"
        contentEl={row?.orderType === AgencyConstants.SaleOrderType.LANDLORD
          ? <>Chuyển trạng thái đơn hàng thành đã duyệt đơn?</>
          : <>Chuyển trạng thái đơn hàng thành đã thanh toán?</>}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async () => {
          AppCustomDialogHelper.hide();
          const result = await AgencyHelper.API.requestUpdateSale(row?.saleId, {
            status: AgencyConstants.SaleOrderStatus.PAID,
          });
          if (result) {
            ToastHelper.showSuccess('Cập nhật đơn hàng thành công');
            requestGetSaleDetail(row?.saleId);
          }
        }}
      />,
      'md',
      false,
      true
    );
  };
  const handleConfirmComplete = async (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
        title="Xác nhận hoàn thành"
        contentEl={
          <>
            Bạn có chắc muốn xác nhận hoàn thành đơn hàng {' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {row?.contractNumber}
            </span>
            {' '} không?
          </>
        }
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (values) => {
          AppCustomDialogHelper.hide();
          const updateOrderResult = await AgencyHelper.API.requestUpdateSale(row?.saleId, {
            status: AgencyConstants.SaleOrderStatus.COMPLETED,
          });
          const result = await AgencyHelper.API.requestUpdateContract(activeContract?.contractId, {
            status: AgencyConstants.ContractStatus.COMPLETED,
          });
          if (result && _.isObject(result) && updateOrderResult && _.isBoolean(updateOrderResult)) {
            ToastHelper.showSuccess('Xác nhận hoàn thành đơn hàng thành công');
            requestGetSaleDetail(saleId);
          } else {
            ToastHelper.showError('Xác nhận hoàn thành đơn hàng thất bại');
          }
        }}
      />,
      'md',
      false,
      true
    );
  };
  const handleViewFiles = (files) => {
    AppCustomDialogHelper.show(
      'Tệp đính kèm',
      <FileUploadView
        pathList={files}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
      />,
      'md',
      false,
      true
    );
  };

  const handleShowAppendicesList = (appendices, contractId) => {
    AppCustomDialogHelper.show(
      'Thông tin phụ lục hợp đồng',
      <AppendicesListView
        appendicesList={appendices}
        contractId={contractId}
        onRefresh={() => {
          requestGetSaleDetail(saleDetail?.saleId);
        }}
      />,
      'xl',
      false,
      true
    )
  }

  const typeMap = {
    CAR: "Ô tô",
    BIKE: "Xe máy"
  };

  const handleGetRentingForm = (row) => {
    const landlordCommission = row?.landlord?.commissions?.find(
      (commission) => commission?.role === 'LANDLORD'
        && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
    );

    if (!row) return 'Không xác định';

    const hasMonthlyRent = row.monthlyRent > 0;
    const hasLandlordCommission = !!landlordCommission;

    if (!hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Miễn phí';
    if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';
    if (hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Có phí';
    if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';

    return 'Không xác định';
  };

  const handleGetRentingCost = (row) => {
    const landlordCommission = row?.landlord?.commissions?.find(
      (commission) => commission?.role === 'LANDLORD'
        && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
    );

    if (!row) return 'Không xác định';

    const hasMonthlyRent = row.monthlyRent > 0;
    const hasLandlordCommission = !!landlordCommission;

    if (!hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return '';
    if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chia sẻ doanh thu điện';
    if (hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Phí thuê cố định';
    if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chi phí thuê kết hợp';

    return 'Không xác định';
  };

  const getContractTitle = (orderType) => {
    switch (orderType) {
      case AgencyConstants.SaleOrderType.INVESTOR:
        return 'mua bán';
      case AgencyConstants.SaleOrderType.COINVESTOR:
        return 'liên kết';
      case AgencyConstants.SaleOrderType.GROUP:
        return 'HTKD';
      case AgencyConstants.SaleOrderType.LANDLORD:
        return 'HTMB';
      case AgencyConstants.SaleOrderType.CHARGEPOINT:
        return 'mua bán';
      default:
        return '';
    }
  }

  return (
    <div>
      <div className="">
        {/* tieu de & wizard */}
        <div>
          {UIHelper.buildCard(
            <div>
              {/* tieu de */}
              <div className="d-flex align-items-center justify-content-between px-4 py-4">
                <div className="flex-fill">
                  <div className="d-flex align-items-center gap-2">
                    <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                      {`Đơn hàng ${saleDetail?.saleCode}`}
                    </span>
                    <KTLabel
                      text={AgencyHelper.Utils.getSaleOrderStatusName(saleDetail?.status, saleDetail?.orderType)}
                      isInline={true}
                      size={KTLabelSize.medium}
                      additionalClassName={`label-light-${AgencyHelper.Utils.getSaleOrderStatusColor(
                        saleDetail?.status
                      )}`}
                    />
                  </div>
                  <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                    Ngày tạo:{' '}
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                      {Utils.formatDateTimeToString(saleDetail?.createdAt, 'DD/MM/YYYY - HH:mm')}
                    </span>
                  </span>
                </div>
                <div className="d-flex align-items-center gap-3">
                  {isAdmin &&
                    (saleDetail?.orderType === AgencyConstants.SaleOrderType.GROUP &&
                      saleDetail?.status === AgencyConstants.SaleOrderStatus.ORDERED) &&
                    UIHelper.buildGreenButton('Duyệt thanh toán', () => {
                      handleUpdateSaleOrderPaid(saleDetail);
                    })}
                  {isAdmin &&
                    (saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR &&
                      saleDetail?.status === AgencyConstants.SaleOrderStatus.ORDERED &&
                      _.first(saleDetail?.contracts)?.status === AgencyConstants.ContractStatus.COMPLETED) &&
                    UIHelper.buildGreenButton('Duyệt tạm ứng', () => {
                      handleUpdateSaleOrderPaid(saleDetail);
                    })}
                  {isAdmin &&
                    ((saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD &&
                      saleDetail?.status === AgencyConstants.SaleOrderStatus.ORDERED)) &&
                    <>
                      {Utils.checkPermission(permissionList, AppConstants.permissionCode.orderUpdate.code) &&
                        UIHelper.buildNegativeButton('Thiết lập hoa hồng và phí thuê', () => {
                          Utils.openInNewTab(`${AppRoute.premisesList}/${saleDetail?.premise?.premiseId}/edit`)
                        })}
                      {Utils.checkPermission(permissionList, AppConstants.permissionCode.orderUpdate.code) &&
                        UIHelper.buildGreenButton('Duyệt đơn hàng', () => {
                          // const hasPremiseSaleCommission = premiseDetail?.agency?.commissions?.find(
                          //   (commission) => commission?.role === 'SALE'
                          //     && premiseDetail?.chargeStations?.length && premiseDetail?.chargeStations?.some(station => station?.stationId === commission?.stationId)
                          // );
                          // if (!!hasPremiseSaleCommission) {
                          handleUpdateSaleOrderPaid(saleDetail);
                          // } else {
                          //   ToastHelper.showError('Bạn cần thiết lập trạm sạc và hoa hồng giới thiệu mặt bằng trước khi duyệt đơn hàng');
                          // }
                        })}
                    </>}
                  {isAdmin &&
                    ((saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD &&
                      saleDetail?.status === AgencyConstants.SaleOrderStatus.PAID) && (
                        activeAcceptanceReport?.status === AgencyConstants.AcceptanceStatus.COMPLETED
                      )) &&
                    <>
                      {UIHelper.buildGreenButton('Xác nhận hoàn thành', () => {
                        handleConfirmComplete(saleDetail);
                      })}
                    </>}
                  {isAdmin &&
                    ((saleDetail?.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT &&
                      saleDetail?.status === AgencyConstants.SaleOrderStatus.ORDERED)) &&
                    <>
                      {UIHelper.buildGreenButton('Đã thanh toán', () => {
                        handleUpdateSaleOrderPaid(saleDetail);
                      })}
                    </>}
                  {!_.isEmpty(buildMoreActionsSaleOrder(saleDetail)) && (
                    <VITableRowDropDown
                      toggleElement={
                        <a className="btn btn-sm btn-clean btn-icon h-45px w-45px btn-light">
                          <i
                            className="fa-solid fa-ellipsis"
                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                          />
                        </a>
                      }
                      menuItem={buildMoreActionsSaleOrder(saleDetail)}
                      singleBtnBgColor={AppColors.gray[200]}
                    />
                  )}
                </div>
              </div>

              {/* wizard */}
              <div>
                <AgencySaleOrderWizardView
                  orderItem={saleDetail}
                  contractItem={
                    !_.isEmpty(contractList)
                      ? _.maxBy(contractList, 'contractId')
                      : _.maxBy(saleDetail?.contracts, 'contractId')
                  }
                  orderType={saleDetail?.orderType}
                  technicalAcceptance={technicalAcceptance}
                  financialAcceptance={financialAcceptance}
                />
              </div>
            </div>,
            false
          )}
        </div>

        {/* ds hop dong */}
        {(
          [
            AgencyConstants.SaleOrderStatus.PAID,
            AgencyConstants.SaleOrderStatus.COMPLETED,
            AgencyConstants.SaleOrderStatus.CANCELLED,
            AgencyConstants.SaleOrderStatus.INSTALLED,
          ].includes(saleDetail?.status) ||
          (saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR
            || saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR
          ) &&
          [
            AgencyConstants.SaleOrderStatus.ORDERED,
            AgencyConstants.SaleOrderStatus.PAID,
            AgencyConstants.SaleOrderStatus.INSTALLED,
            AgencyConstants.SaleOrderStatus.COMPLETED,
            AgencyConstants.SaleOrderStatus.CANCELLED,
          ].includes(saleDetail?.status)
        ) ? (
          <div className="mt-4">
            {UIHelper.buildCard(
              <div className="pb-4">
                {/* header */}
                <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                  <div className="d-flex flex-column">
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                      Danh sách hợp đồng
                    </span>
                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[800])}>
                      Tổng:{' '}
                      <span style={UIHelper.buildFontStyle('600', '13px', AppColors.primary)}>
                        {contractList?.length} hợp đồng
                      </span>
                    </span>
                  </div>
                  <div>
                    {(
                      (
                        saleDetail?.orderType !== AgencyConstants.SaleOrderType.INVESTOR &&
                        saleDetail?.status !== AgencyConstants.SaleOrderStatus.ORDERED
                      ) ||
                      (
                        (saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR
                          || saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR
                        ) &&
                        saleDetail?.status === AgencyConstants.SaleOrderStatus.ORDERED
                      )
                    ) &&
                      isAdmin &&
                      UIHelper.buildGreenButton(
                        'Tạo hợp đồng ' + getContractTitle(saleDetail?.orderType),
                        saleDetail?.status === AgencyConstants.SaleOrderStatus.CANCELLED ? null : handleCreateContract,
                        <i className="fa-regular fa-circle-plus" />,
                        false,
                        creatingContract
                      )
                    }
                  </div>
                </div>

                {/* danh sach hop dong */}
                <div className="px-4">
                  <KTTable
                    columns={contractColumns}
                    items={contractList}
                    selectableRows={false}
                    striped={false}
                    compactGrid={false}
                    onClickedRow={(row) => { }}
                    onSelectedRowsChanged={(rows) => { }}
                    onDoubleClickedRow={(row) => { }}
                    hasActionColumn={isAdmin || isBuyer}
                    noDataComponent={
                      <EmptyView
                        icon={null}
                        title="Không có dữ liệu để hiển thị"
                        text={<span>Hiện tại không có hợp đồng nào cho đơn hàng này.</span>}
                      />
                    }
                  />
                </div>
              </div>,
              false
            )}
          </div>
        ) : (
          <> </>
        )}

        {/* ds bien ban nghiem thu */}
        {showAcceptanceList ? (
          <div className="mt-4">
            {UIHelper.buildCard(
              <div className="pb-4">
                {/* header */}
                <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                  <div className="d-flex flex-column">
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                      Danh sách biên bản nghiệm thu
                    </span>
                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[800])}>
                      Tổng:{' '}
                      <span style={UIHelper.buildFontStyle('600', '13px', AppColors.primary)}>
                        {acceptanceReportList?.length} biên bản
                      </span>
                    </span>
                  </div>
                  <div>
                    {isAdmin && (
                      <>
                        {(!technicalAcceptance || technicalAcceptance?.status !== AgencyConstants.AcceptanceStatus.COMPLETED) ? (
                          UIHelper.buildGreenButton(
                            <>Tạo biên bản nghiệm thu kỹ thuật</>,
                            (!technicalAcceptance || technicalAcceptance?.status === AgencyConstants.AcceptanceStatus.CANCELLED)
                              ? handleCreateTechnicalAcceptanceReport
                              : null,
                            <i className="fa-regular fa-circle-plus" />
                          )
                        ) :
                          saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR
                            ? (
                              UIHelper.buildGreenButton(
                                <>Tạo biên bản nghiệm thu thanh toán</>,
                                (!financialAcceptance || financialAcceptance?.status === AgencyConstants.AcceptanceStatus.CANCELLED)
                                  ? handleCreateFinancialAcceptanceReport
                                  : null,
                                <i className="fa-regular fa-circle-plus" />
                              )
                            )
                            : <></>}
                      </>
                    )}
                  </div>
                </div>

                {/* danh sach bien ban */}
                <div className="px-4">
                  <KTTable
                    columns={acceptanceReportColumns}
                    items={acceptanceReportList}
                    selectableRows={false}
                    striped={false}
                    compactGrid={false}
                    onClickedRow={(row) => { }}
                    onSelectedRowsChanged={(rows) => { }}
                    onDoubleClickedRow={(row) => { }}
                    hasActionColumn={!isSale}
                    noDataComponent={
                      <EmptyView
                        icon={null}
                        title="Không có dữ liệu để hiển thị"
                        text={<span>Hiện tại không có biên bản nghiệm thu nào cho đơn hàng này.</span>}
                      />
                    }
                  />
                </div>
              </div>,
              false
            )}
          </div>
        ) : (
          <> </>
        )}

        <div className="mt-4">
          {UIHelper.buildCard(
            <div>
              {saleDetail ? (
                <>
                  <div className="row m-0 p-0 px-2">
                    {/* ds san pham */}
                    <div className="col-lg-8 mb-4 px-2">
                      {saleDetail?.orderType === AgencyConstants.SaleOrderType.GROUP
                        ? (
                          // ds goi dau tu HTKD
                          <div className="mt-4">
                            <div
                              className="mb-2"
                              style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                            >
                              Danh sách gói đầu tư HTKD
                            </div>
                            {UIHelper.buildCardInfo(
                              <div>
                                {saleDetail?.items?.length > 0 ? (
                                  <div className="table-responsive">
                                    <table className="table mb-0">
                                      <thead>
                                        <tr>
                                          <th
                                            className="align-top py-2"
                                            style={{
                                              ...UIHelper.buildFontStyle(
                                                '600',
                                                '12px',
                                                AppColors.gray[900]
                                              ),
                                              backgroundColor: AppColors.gray[100],
                                              borderRight: `1px solid ${AppColors.gray[300]}`,
                                              borderBottom: `1px solid ${AppColors.gray[300]}`,
                                            }}
                                          >
                                            Sản phẩm
                                          </th>
                                          <th
                                            className="text-right w-150px py-2"
                                            style={{
                                              ...UIHelper.buildFontStyle(
                                                '600',
                                                '12px',
                                                AppColors.gray[900]
                                              ),
                                              backgroundColor: AppColors.gray[100],
                                              borderBottom: `1px solid ${AppColors.gray[300]}`,
                                            }}
                                          >
                                            <div className="d-flex flex-column">
                                              <span
                                                style={UIHelper.buildFontStyle(
                                                  '600',
                                                  '12px',
                                                  AppColors.gray[900]
                                                )}
                                              >
                                                Số tiền
                                              </span>
                                              <span
                                                style={UIHelper.buildFontStyle(
                                                  '500',
                                                  '12px',
                                                  AppColors.gray[700]
                                                )}
                                              >
                                                VNĐ
                                              </span>
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {saleDetail?.items?.map((item, index) => {
                                          return (
                                            <tr key={`SALE_ITEM_${item?.itemId}`}>
                                              <td
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '600',
                                                    '13px',
                                                    AppColors.primary
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                  borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                <span
                                                  className="hover-opacity-60 cursor-pointer"
                                                  onClick={() => {
                                                    Utils.openInNewTab(`${AppRoute.investmentPackList}`)
                                                  }}
                                                >
                                                  {item?.investment?.packageId
                                                    ? item?.investment?.description
                                                    : 'Gói tuỳ chọn'}
                                                </span>
                                              </td>
                                              <td
                                                className="text-right"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                  borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                {Utils.formatNumber(item?.amount ?? 0)}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                        <tr>
                                          <td
                                            className="text-right border-bottom-0"
                                            style={{
                                              ...UIHelper.buildFontStyle(
                                                '500',
                                                '13px',
                                                AppColors.gray[700]
                                              ),
                                              borderRight: `1px solid ${AppColors.gray[300]}`,
                                            }}
                                          >
                                            Tổng tiền
                                          </td>
                                          <td
                                            className="text-right border-0"
                                            style={{
                                              ...UIHelper.buildFontStyle(
                                                '700',
                                                '14px',
                                                AppColors.primary
                                              ),
                                            }}
                                          >
                                            {Utils.formatNumber(saleDetail?.amount ?? 0)}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <div>
                                    <EmptyView
                                      icon={imgEmptyNoData}
                                      title="Không có dữ liệu"
                                      text={
                                        <span>
                                          Hiện tại không có sản phẩm nào trong đơn hàng này.
                                        </span>
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )
                        : (saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR
                          || saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR
                        )
                          ? (
                            // ds sản phẩm
                            <div className='d-flex flex-column gap-3'>
                              <div>
                                <div
                                  className="mb-2 pt-4"
                                  style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                                >
                                  Danh sách sản phẩm
                                </div>
                                {UIHelper.buildCardInfo(
                                  <div>
                                    {saleModelItemsWithQuantity?.length > 0 ? (
                                      <div className="table-responsive">
                                        <table className="table mb-0">
                                          <thead>
                                            <tr>
                                              {[
                                                { label: 'Sản phẩm', unit: '', className: "align-top py-2" },
                                                { label: 'Đơn vị tính', unit: '', className: "align-top py-2 text-right" },
                                                { label: 'Số lượng', unit: '', className: "align-top py-2 text-right" },
                                                { label: 'Đơn giá', unit: 'VNĐ', className: "text-right w-150px py-2" },
                                                { label: 'Thành tiền', unit: 'VNĐ', className: "text-right w-150px py-2" },
                                                { label: 'Thuế suất', unit: '%', className: "align-top py-2" },
                                              ].map((col, index) => (
                                                <th
                                                  key={index}
                                                  className={col.className}
                                                  style={{
                                                    ...UIHelper.buildFontStyle(
                                                      '600',
                                                      '12px',
                                                      AppColors.gray[900]
                                                    ),
                                                    backgroundColor: AppColors.gray[100],
                                                    borderRight: index != 5 && `1px solid ${AppColors.gray[300]}`,
                                                  }}
                                                >
                                                  {UIHelper.buildTableColumn(col.label, col.unit)}
                                                </th>
                                              ))}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {saleModelItemsWithQuantity?.map((item, index) => {
                                              return (
                                                <tr key={`SALE_ITEM_${item?.modelId}`}>
                                                  <td
                                                    className='border-bottom-0'
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '600',
                                                        '13px',
                                                        AppColors.primary
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    <span
                                                      className="hover-opacity-60 cursor-pointer"
                                                      onClick={() => {
                                                        if (item?.productType === 'CHARGE_MODEL') {
                                                          Utils.openInNewTab(`${AppRoute.manageChargeBrand}/${item?.brandId ?? ''}`)
                                                        } else if (item?.productType === 'INVENTORY') {
                                                          Utils.openInNewTab(`${AppRoute.inventoryList}`)
                                                        }
                                                      }}
                                                    >
                                                      {!!item?.type
                                                        ? `[${item?.type}] ${item?.model}`
                                                        : item?.model}
                                                    </span>
                                                  </td>
                                                  <td
                                                    className="border-bottom-0"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    <span className="">
                                                      {item?.unit}
                                                    </span>
                                                  </td>
                                                  <td
                                                    className="text-right border-bottom-0"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    <span className="">
                                                      {Utils.formatNumber(item?.quantity)}
                                                    </span>
                                                  </td>
                                                  <td
                                                    className="text-right border-bottom-0"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    {Utils.formatNumber(item?.amount ?? 0)}
                                                  </td>
                                                  <td
                                                    className="text-right border-bottom-0"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    {Utils.formatNumber(
                                                      _.toNumber(item?.amount) *
                                                      _.toNumber(item?.quantity)
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right border-bottom-0"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                    }}
                                                  >
                                                    {item?.taxRate === 0 ? 'KCT' : item?.taxRate}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                            <tr key={`CATEGORY_ITEM`}>
                                              <td
                                                className='border-bottom-0'
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '600',
                                                    '13px',
                                                    AppColors.gray[800]
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                <span
                                                  className="cursor-pointer"
                                                  onClick={() => { }}
                                                >
                                                  Chi phí thi công, vật tư lắp đặt, vận chuyển,… dự tính
                                                </span>
                                              </td>
                                              <td
                                                className="border-bottom-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                <span className="">
                                                  Gói
                                                </span>
                                              </td>
                                              <td
                                                className="text-right border-bottom-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                <span className="">
                                                  1
                                                </span>
                                              </td>
                                              <td
                                                className="text-right border-bottom-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                {Utils.formatNumber(saleDetail?.serviceAmount ?? 0)}
                                              </td>
                                              <td
                                                className="text-right border-bottom-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                {Utils.formatNumber(saleDetail?.serviceAmount ?? 0)}
                                              </td>
                                              <td
                                                className="text-right border-bottom-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                }}
                                              >
                                                KCT
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <div>
                                        <EmptyView
                                          icon={imgEmptyNoData}
                                          title="Không có dữ liệu"
                                          text={
                                            <span>
                                              Hiện tại không có sản phẩm nào trong đơn hàng này.
                                            </span>
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              {saleModelItemsWithQuantity?.length > 0 ? (
                                <div className="rounded w-100" style={{ border: `1px solid ${AppColors.gray[300]}` }}>
                                  {[
                                    {
                                      label: "Tổng tiền trụ sạc (trước thuế)",
                                      value: saleModelItemsWithQuantity?.reduce((sum, item) => {
                                        if (item?.type && item?.amount && item?.quantity) {
                                          return sum + item.amount * item.quantity;
                                        }
                                        return sum;
                                      }, 0) || 0
                                    },
                                    {
                                      label: "Tổng tiền trang thiết bị & dịch vụ (trước thuế)",
                                      value: (saleDetail?.serviceAmount ?? 0) + (_.sumBy(saleDetail?.inventoryItems, 'amountBeforeTax') ?? 0)
                                    },
                                    {
                                      label: "Khoản phát sinh tăng/giảm (trước thuế)",
                                      value: otherAmount || 0,
                                      additionalInfo: otherAmount > 0 ? '+' : '',
                                    },
                                    {
                                      label: "Thuế VAT",
                                      value: taxAmount || 0
                                    },
                                    // { label: "Giá trị hợp đồng", value: (saleDetail?.amount + taxAmount) || 0 },
                                    { label: "Tổng tiền (sau thuế)", value: saleDetail?.amountAfterTax || 0 },
                                  ].map((item, index) => (
                                    <div key={index} className="d-flex w-100"
                                      style={{
                                        borderBottom: index != 4 && `1px dashed ${AppColors.gray[200]}`
                                      }}
                                    >
                                      <div
                                        className="w-75 p-2"
                                        style={{
                                          ...UIHelper.buildFontStyle("500", "13px", AppColors.gray[700]),
                                          borderRight: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        {item.label}
                                      </div>
                                      <div
                                        className="w-25 p-2 text-right"
                                        style={
                                          index != 5
                                            ? UIHelper.buildFontStyle("500", "13px", AppColors.gray[700])
                                            : UIHelper.buildFontStyle("700", "14px", AppColors.primary)
                                        }
                                      >
                                        {item?.additionalInfo}{Utils.formatNumber(item.value)}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          )
                          : (saleDetail?.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT)
                            ? (
                              // ds dòng trụ sạc
                              <div>
                                <div
                                  className="mb-2 pt-4"
                                  style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                                >
                                  Danh sách sản phẩm
                                </div>
                                {UIHelper.buildCardInfo(
                                  <div>
                                    {saleModelItemsWithQuantity?.length > 0 ? (
                                      <div className="table-responsive">
                                        <table className="table mb-0">
                                          <thead>
                                            <tr>
                                              <th
                                                className="align-top py-2"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '600',
                                                    '12px',
                                                    AppColors.gray[900]
                                                  ),
                                                  backgroundColor: AppColors.gray[100],
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                  borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                Sản phẩm
                                              </th>
                                              <th
                                                className="align-top py-2 text-right"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '600',
                                                    '12px',
                                                    AppColors.gray[900]
                                                  ),
                                                  backgroundColor: AppColors.gray[100],
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                  borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                Số lượng
                                              </th>
                                              <th
                                                className="text-right w-150px py-2"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '600',
                                                    '12px',
                                                    AppColors.gray[900]
                                                  ),
                                                  backgroundColor: AppColors.gray[100],
                                                  borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                <div className="d-flex flex-column">
                                                  <span
                                                    style={UIHelper.buildFontStyle(
                                                      '600',
                                                      '12px',
                                                      AppColors.gray[900]
                                                    )}
                                                  >
                                                    Đơn giá
                                                  </span>
                                                  <span
                                                    style={UIHelper.buildFontStyle(
                                                      '500',
                                                      '12px',
                                                      AppColors.gray[700]
                                                    )}
                                                  >
                                                    VNĐ
                                                  </span>
                                                </div>
                                              </th>
                                              <th
                                                className="text-right w-150px py-2"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '600',
                                                    '12px',
                                                    AppColors.gray[900]
                                                  ),
                                                  backgroundColor: AppColors.gray[100],
                                                  borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                <div className="d-flex flex-column">
                                                  <span
                                                    style={UIHelper.buildFontStyle(
                                                      '600',
                                                      '12px',
                                                      AppColors.gray[900]
                                                    )}
                                                  >
                                                    Thành tiền
                                                  </span>
                                                  <span
                                                    style={UIHelper.buildFontStyle(
                                                      '500',
                                                      '12px',
                                                      AppColors.gray[700]
                                                    )}
                                                  >
                                                    VNĐ
                                                  </span>
                                                </div>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {saleModelItemsWithQuantity?.map((item, index) => {
                                              return (
                                                <tr key={`SALE_ITEM_${item?.modelId}`}>
                                                  <td
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '600',
                                                        '13px',
                                                        AppColors.primary
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                      borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    <span
                                                      className="hover-opacity-60 cursor-pointer"
                                                      onClick={() => {
                                                        if (item?.productType === 'CHARGE_MODEL') {
                                                          Utils.openInNewTab(`${AppRoute.manageChargeBrand}/${item?.brandId ?? ''}`)
                                                        }
                                                      }}
                                                    >
                                                      {`[${item?.type}] ${item?.model}`}
                                                    </span>
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                      borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    <span className="">
                                                      {Utils.formatNumber(item?.quantity)}
                                                    </span>
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                      borderRight: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    {Utils.formatNumber(item?.amount ?? 0)}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{
                                                      ...UIHelper.buildFontStyle(
                                                        '500',
                                                        '13px',
                                                        AppColors.gray[700]
                                                      ),
                                                      borderBottom: `1px solid ${AppColors.gray[300]}`,
                                                    }}
                                                  >
                                                    {Utils.formatNumber(
                                                      _.toNumber(item?.amount) *
                                                      _.toNumber(item?.quantity)
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                            <tr>
                                              <td className="border-bottom-0" style={{}}></td>
                                              <td className="border-bottom-0" style={{}}></td>
                                              <td
                                                className="text-right border-bottom-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '500',
                                                    '13px',
                                                    AppColors.gray[700]
                                                  ),
                                                  borderRight: `1px solid ${AppColors.gray[300]}`,
                                                }}
                                              >
                                                Tổng tiền
                                              </td>
                                              <td
                                                className="text-right border-0"
                                                style={{
                                                  ...UIHelper.buildFontStyle(
                                                    '700',
                                                    '14px',
                                                    AppColors.primary
                                                  ),
                                                }}
                                              >
                                                {Utils.formatNumber(saleDetail?.amount ?? 0)}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <div>
                                        <EmptyView
                                          icon={imgEmptyNoData}
                                          title="Không có dữ liệu"
                                          text={
                                            <span>
                                              Hiện tại không có sản phẩm nào trong đơn hàng này.
                                            </span>
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )
                            : saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD
                              ? (
                                <div className='pt-4'>
                                  {AgencyUIHelper.buildTableInfo(t('Thông tin mặt bằng giới thiệu'), [
                                    {
                                      name: t('Tên mặt bằng'),
                                      value: saleDetail?.premise?.name,
                                      color: AppColors.primary,
                                      action: () => {
                                        Utils.openInNewTab(`${AppRoute.premisesList}/${saleDetail?.premise?.premiseId}`)
                                      }
                                    },
                                    {
                                      name: t('Loại mặt bằng'),
                                      value: commissionRateLandlord ? JSON.parse(commissionRateLandlord)?.find(landlord => landlord?.key === saleDetail?.premise?.type)?.name : '',
                                      color: AppColors.gray[800],
                                    },
                                    {
                                      name: t('Diện tích'),
                                      value: saleDetail?.premise?.floorArea ? saleDetail?.premise?.floorArea + ' m2' : '',
                                      color: AppColors.gray[800],
                                    },
                                    {
                                      name: t('Loại phương tiện'),
                                      value: saleDetail?.premise?.vehicleTypes?.length > 0
                                        ? saleDetail?.premise?.vehicleTypes?.map((type, index) => index === 0 ? typeMap[type] : typeMap[type].toLowerCase()).join(", ")
                                        : '',
                                      color: AppColors.gray[800]
                                    },
                                    {
                                      name: t('Số chỗ đỗ xe ô tô'),
                                      value: saleDetail?.premise?.parkingSlots ?? '',
                                      color: AppColors.gray[800],
                                    },
                                    {
                                      name: t('Phạm vi thuê'),
                                      value: saleDetail?.premise?.rentingType ? AgencyHelper.Data.rentingTypeOptions.find(type => type.value === saleDetail?.premise?.rentingType)?.name : '',
                                      color: AppColors.gray[800],
                                    },
                                    {
                                      name: t('Địa chỉ'),
                                      value: saleDetail?.premise?.address ? ChargeHelper.Utils.getChargeStationFullAddress(saleDetail?.premise) : '',
                                      color: AppColors.gray[800],
                                    },
                                    {
                                      name: t('Mô tả mặt bằng'),
                                      value: saleDetail?.premise?.description ?? '',
                                      color: AppColors.gray[800],
                                    }
                                  ])}
                                </div>
                              )
                              : (
                                <></>
                              )}

                      {/* thong tin cac ben tham gia */}
                      <div
                        className="row m-0 p-0 mt-4 pt-2"
                        style={{
                          borderTop: `1px dashed ${AppColors.gray[300]}`,
                          borderBottom: `1px dashed ${AppColors.gray[300]}`,
                        }}
                      >
                        {/* thong tin ben ban */}
                        {/* <div className="pl-0 mb-4 mb-lg-0 col-lg-4">
                          <div
                            className="mb-2"
                            style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                          >
                            Thông tin bên bán
                          </div>
                          {UIHelper.buildCardInfo(
                            <div>
                              {UIHelper.buildCardCellItem(
                                'Nhà điều hành',
                                saleOperatorDetail?.name,
                                () => {}
                              )}
                              {UIHelper.buildCardCellItem(
                                'Số điện thoại',
                                saleOperatorDetail?.phone
                              )}
                              {UIHelper.buildCardCellItem('Email', saleOperatorDetail?.email, null)}
                              {UIHelper.buildCardCellItem(
                                'Địa chỉ',
                                saleOperatorDetail?.address,
                                null,
                                false
                              )}
                            </div>
                          )}
                        </div> */}
                        {/* thong tin dai ly ban hang */}
                        <div className="pl-0 pr-0 pr-lg-2 mb-4 mb-lg-0 col-lg-6">
                          <div
                            className="mb-2"
                            style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                          >
                            {saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD
                              ? 'Thông tin bên giới thiệu'
                              : 'Thông tin bên bán'
                            }
                          </div>
                          {UIHelper.buildCardInfo(
                            <div>
                              {UIHelper.buildCardCellItem(
                                saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD
                                  ? 'Người giới thiệu'
                                  : 'Người bán hàng',
                                saleDetail?.agency?.name,
                                () => {
                                  AgencyHelper.Navigation.navigateToAgencyDetail(null, saleDetail?.agency);
                                }
                              )}
                              {UIHelper.buildCardCellItem(
                                'Số điện thoại',
                                saleDetail?.agency?.phone
                              )}
                              {UIHelper.buildCardCellItem('Email', saleDetail?.agency?.email, null)}
                              {UIHelper.buildCardCellItem(
                                'Địa chỉ',
                                saleDetail?.agency?.address,
                                null,
                                false
                              )}
                            </div>
                          )}
                        </div>
                        {/* thong tin ben mua */}
                        <div className="pr-0 pl-0 pl-lg-2 mb-4 col-lg-6">
                          <div
                            className="mb-2"
                            style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                          >
                            {saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD
                              ? 'Thông tin bên cho thuê'
                              : 'Thông tin bên mua'
                            }
                          </div>
                          {UIHelper.buildCardInfo(
                            <div>
                              {UIHelper.buildCardCellItem(

                                saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD
                                  ? 'Chủ mặt bằng'
                                  : 'Nhà đầu tư',
                                saleDetail?.buyer?.name,
                                () => {
                                  AgencyHelper.Navigation.navigateToAgencyDetail(null, saleDetail?.buyer);
                                }
                              )}
                              {UIHelper.buildCardCellItem(
                                'Số điện thoại',
                                saleDetail?.buyer?.phone
                              )}
                              {UIHelper.buildCardCellItem('Email', saleDetail?.buyer?.email, null)}
                              {UIHelper.buildCardCellItem(
                                'Địa chỉ',
                                saleDetail?.buyer?.address,
                                null,
                                false
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* tong quan don hang & ghi chu */}
                    <div className="col-lg-4 mb-4 px-2">
                      {/* tong quan don hang */}
                      <div>
                        <div
                          className="mb-2 pt-0 pt-lg-4"
                          style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                        >
                          Tổng quan đơn hàng
                        </div>
                        {UIHelper.buildCardInfo(
                          <div>
                            {UIHelper.buildCardCellItem(
                              'Loại đơn hàng',
                              AgencyHelper.Utils.getSaleOrderTypeName(saleDetail?.orderType)
                            )}
                            {saleDetail?.orderType !== AgencyConstants.SaleOrderType.LANDLORD && UIHelper.buildCardCellItem(
                              'Tổng tiền',
                              Utils.formatNumber(saleDetail?.amountAfterTax || saleDetail?.amount) +
                              ' ' +
                              'VNĐ'
                            )}
                            {UIHelper.buildCardCellItem(
                              'Trạng thái',
                              <KTLabel
                                text={AgencyHelper.Utils.getSaleOrderStatusName(saleDetail?.status, saleDetail?.orderType)}
                                isInline={true}
                                size={KTLabelSize.medium}
                                additionalClassName={`label-light-${AgencyHelper.Utils.getSaleOrderStatusColor(
                                  saleDetail?.status
                                )}`}
                              />
                            )}
                            {UIHelper.buildCardCellItem(
                              'Người tạo',
                              saleDetail?.user?.fullname,
                            )}
                            {UIHelper.buildCardCellItem(
                              'Ngày tạo',
                              Utils.formatDateTimeToString(saleDetail?.time, 'DD/MM/YYYY - HH:mm'),
                              null,
                              saleDetail?.attachedFiles?.length > 0
                            )}
                            {saleDetail?.attachedFiles?.length > 0 &&
                              UIHelper.buildCardCellItem(
                                'Tệp đính kèm',
                                saleDetail?.attachedFiles?.length > 0
                                  ? 'Xem tệp đính kèm (' + saleDetail?.attachedFiles?.length + ')'
                                  : 'Không có',
                                saleDetail?.attachedFiles?.length > 0
                                  ? () => {
                                    // router.navigate(`${AppRoute.agencySaleAddOrder}/${saleId}`);
                                    handleViewFiles(saleDetail?.attachedFiles);
                                  }
                                  : null,
                                false
                              )}
                          </div>
                        )}
                      </div>

                      {/* ghi chu */}
                      {saleDetail?.note && (
                        <div className="mt-4">
                          <div
                            className="mb-2"
                            style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}
                          >
                            Ghi chú
                          </div>
                          {UIHelper.buildCardInfo(
                            <div className="p-4">
                              <span
                                style={UIHelper.buildFontStyle('400', '13px', AppColors.gray[800])}
                              >
                                {saleDetail?.note}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <EmptyView
                  icon={imgEmptyNoData}
                  title="Không có dữ liệu"
                  text={<span>Không lấy được thông tin đơn hàng.</span>}
                />
              )}
            </div>,
            false
          )}
        </div>
      </div>
    </div >
  );
}

export default AgencySaleDetailView;
